import {
  CORE_LOAD_SUGGEST_INFORMATION_REQUEST,
  CORE_LOAD_SUGGEST_INFORMATION_SUCCESS,
  CORE_LOAD_SUGGEST_INFORMATION_FAILURE,
} from '../types'
const requestState = 'request'
  , initialStateObj = {}
// , initialState = []

export default {
  suggestInformation: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_SUGGEST_INFORMATION_REQUEST:
        return requestState
      case CORE_LOAD_SUGGEST_INFORMATION_SUCCESS:
        let result = {}
        if (result && Object.keys(action.payload).length > 0) {
          result = action.payload
        }
        return result
      case CORE_LOAD_SUGGEST_INFORMATION_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerSetting.js